module.exports = __webpack_public_path__ + "static/img/cont32_10.82b5dcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont32_10.jpg
// module id = 6oP0
// module chunks = 0